import { create } from 'zustand';

interface CardImageAspectRatioState {
  ratios: Record<string, number>;
}

interface CardImageAspectRatioActions {
  setCardImageAspectRatio: (cardId: string, ratio: number) => void;
}

export type CardImageAspectRatioStore = CardImageAspectRatioState & CardImageAspectRatioActions;

export const useCardImageAspectRatioStore = create<CardImageAspectRatioStore>((set) => ({
  ratios: {},
  setCardImageAspectRatio: (cardId, ratio) => {
    if (!Number.isFinite(ratio) || ratio <= 0) {
      return;
    }

    set((state) => {
      if (state.ratios[cardId] === ratio) {
        return state;
      }

      return {
        ratios: {
          ...state.ratios,
          [cardId]: ratio,
        },
      };
    });
  },
}));
